import smartsuppIcon from '@/assets/img/logo/integrations/smartsupp.png'

export const SMARTSUPP_INTEGRATION = {
  type: 'smartsupp',
  category: 'Helpdesk',
  icon: smartsuppIcon,
  description: 'Smartsupp live chat allows operators to easily resolve customer queries via an intuitive web UI.'
}

export const AVAILABLE_INTEGRATIONS = [
  SMARTSUPP_INTEGRATION
]
